<template>
  <div id="instrumentPanel"
       style="width:100%;height:100%"></div>
</template>
<script>
import echarts from "echarts";
export default {
  props: ['width', "height", "data"],
  // data = { value: 40000, name: '历史扫码量', unit: '次数' }

  watch: {
    data: {
      handler: function () {
        // if (!this.max) {
        //   this.max = 100
        // }
        this.max = 1000
        this.getMax(this.data.value)
        this.multiple = this.max / 100

        this.initChart()
      },
      deep: true    }
  },
  data () {
    return {
      multiple: 1,
      max: 1000,
      unit: {
        4: '万', 5: '0万', 6: '00万', 7: '000万', 8: '亿', 9: '0亿', 10: '00亿', 11: '000亿'
      },
      len: 4
    }
  },
  mounted () {
    // if (!this.max) {
    //   this.max = 100
    // }
    this.getMax(this.data.value)
    this.multiple = this.max / 100

    this.initChart()
  },
  methods: {
    initChart () {
      let self = this
      let colorTemplate1 = [[0.2, "#FFB52B"], [0.8, "#EB7044"], [1, "#49C8CF"]]
      var myChart = echarts.init(this.$el);
      myChart.getDom().style.height = this.height
      myChart.getDom().style.width = this.width
      // 指定图表的配置项和数据
      myChart.setOption({
        // tooltip: {
        //   formatter: "{a} <br/>{b} : {c}%"
        // },
        toolbox: {
          feature: {
          }
        },

        axisLabel: {
          formatter: function (e) {
            let max = self.max
            if (max) {
              switch (e + "") {
                case "10":
                  return self.len <= 4 ? max * 0.1 : 1 + self.unit[self.len];
                case "20":
                  return self.len <= 4 ? max * 0.2 : 2 + self.unit[self.len];
                case "30":
                  return self.len <= 4 ? max * 0.3 : 3 + self.unit[self.len];
                case "40":
                  return self.len <= 4 ? max * 0.4 : 4 + self.unit[self.len];
                case "50":
                  return self.len <= 4 ? max * 0.5 : 5 + self.unit[self.len];
                case "60":
                  return self.len <= 4 ? max * 0.6 : 6 + self.unit[self.len];
                case "70":
                  return self.len <= 4 ? max * 0.7 : 7 + self.unit[self.len];
                case "80":
                  return self.len <= 4 ? max * 0.8 : 8 + self.unit[self.len];
                case "90":
                  return self.len <= 4 ? max * 0.9 : 9 + self.unit[self.len];
                case "100":
                  return self.len <= 4 ? max * 1 : 10 + self.unit[self.len];
                default:
                  return "";
              }
            }

          }        },
        series: [

          {
            radius: '100%',
            name: '业务指标',
            type: 'gauge',
            axisLabel: { //刻度标签
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 12 * this.$store.state.ratio.hole,
              },
            },

            axisLine: {				// 仪表盘轴线(轮廓线)相关配置。
              show: true,				// 是否显示仪表盘轴线(轮廓线),默认 true。
              lineStyle: {			// 仪表盘轴线样式。
                color: colorTemplate1, 	//仪表盘的轴线可以被分成不同颜色的多段。每段的  结束位置(范围是[0,1]) 和  颜色  可以通过一个数组来表示。默认取值：[[0.2, '#91c7ae'], [0.8, '#63869e'], [1, '#c23531']]
                opacity: 1,					//图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。
                width: 30,					//轴线宽度,默认 30。
                shadowBlur: 20,				//(发光效果)图形阴影的模糊大小。该属性配合 shadowColor,shadowOffsetX, shadowOffsetY 一起设置图形的阴影效果。 
                shadowColor: "#fff",		//阴影颜色。支持的格式同color。
              }
            },

            title: {   //仪表盘标题
              show: true,
              offsetCenter: ['0', '20'],
              textStyle: {
                color: '#fff',
                fontSize: 12 * this.$store.state.ratio.hole,
                fontFamily: 'Microsoft YaHei'
              }
            },
            detail: {
              formatter: function (e) {
                return Math.ceil(e * self.multiple)
              },
              textStyle: {
                fontSize: 18 * this.$store.state.ratio.hole,
              }
            },
            data: [{ value: this.data.value / this.multiple, name: this.data.name }]
          }
        ]
      });

    },
    getMax (data) {
      let str = data + ''
      this.len = str.length - 1
      if (data > this.max) {
        this.max = this.max * 10
        this.getMax(data)
      }
    }
  }
}
</script>